import { AppConsts } from '../../../../shared/AppConsts';
var ImageUrlHelper = /** @class */ (function () {
    function ImageUrlHelper() {
    }
    ImageUrlHelper.getDiagramImageUrlPrefix = function () {
        return AppConsts.remoteServiceBaseUrl + ImageUrlHelper.getDiagramImageMethodPath + '?';
    };
    ImageUrlHelper.buildImageUrl = function (imageId, imageType) {
        if (!imageId || imageId === ImageUrlHelper.defaultImageId) {
            return ImageUrlHelper.defaultImageSource;
        }
        var imageUrl = ImageUrlHelper.getDiagramImageUrlPrefix() + ImageUrlHelper.idQueryStringPrefix + imageId;
        if (imageType) {
            imageUrl += "&" + ImageUrlHelper.typeQueryStringPrefix + imageType;
        }
        return imageUrl;
    };
    ImageUrlHelper.getImageId = function (sourceUrl) {
        var imageId;
        if (sourceUrl) {
            var imageIdIndex = ImageUrlHelper.getImageIdIndex(sourceUrl);
            if (imageIdIndex > -1) {
                var imageTypeIndex = ImageUrlHelper.getImageTypeIndex(sourceUrl);
                if (imageTypeIndex < 0) {
                    imageTypeIndex = sourceUrl.length;
                }
                imageId = sourceUrl.substring(imageIdIndex + ImageUrlHelper.idQueryStringPrefix.length, imageTypeIndex - 1);
            }
        }
        return imageId;
    };
    ImageUrlHelper.getImageType = function (sourceUrl) {
        var imageType;
        if (sourceUrl) {
            var imageTypeIndex = ImageUrlHelper.getImageTypeIndex(sourceUrl);
            if (imageTypeIndex > -1) {
                imageType = sourceUrl.substring(imageTypeIndex + ImageUrlHelper.typeQueryStringPrefix.length);
            }
        }
        return imageType;
    };
    /**
     * Used to format old image url to new url format(in designer view)
     * @param sourceUrl : orignal old image url
     */
    ImageUrlHelper.formatDesignerImageUrl = function (sourceUrl) {
        if (sourceUrl && sourceUrl !== ImageUrlHelper.defaultImageSource) {
            if (sourceUrl.startsWith(ImageUrlHelper.getDiagramImageUrlPrefix())) {
                return sourceUrl;
            }
            else {
                var queryStringIndex = sourceUrl.indexOf(ImageUrlHelper.idQueryStringPrefix);
                if (queryStringIndex >= 0) {
                    var queryString = sourceUrl.substring(queryStringIndex);
                    return ImageUrlHelper.getDiagramImageUrlPrefix() + queryString;
                }
            }
        }
        return ImageUrlHelper.defaultImageSource;
    };
    ImageUrlHelper.getImageIdIndex = function (sourceUrl) {
        if (!sourceUrl) {
            return -1;
        }
        return sourceUrl.indexOf(ImageUrlHelper.idQueryStringPrefix);
    };
    ImageUrlHelper.getImageTypeIndex = function (sourceUrl) {
        if (!sourceUrl) {
            return -1;
        }
        return sourceUrl.indexOf(ImageUrlHelper.typeQueryStringPrefix);
    };
    ImageUrlHelper.defaultImageId = 'defaultImage';
    ImageUrlHelper.defaultImageSource = '/assets/common/images/configure/defaultImage.png';
    // 获取组态图片Controller方法的Url路径
    ImageUrlHelper.getDiagramImageMethodPath = '/ConfigureComponent/GetImage';
    ImageUrlHelper.idQueryStringPrefix = 'id=';
    ImageUrlHelper.typeQueryStringPrefix = 'type=';
    return ImageUrlHelper;
}());
export { ImageUrlHelper };
